import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FuncionarioForm } from "../../components/FuncionarioForm";
import { FuncionarioCreate } from "../../types/Funcionario";
import {
  funcionarioFranquiaService,
  FuncionarioFranquiaService,
} from "../../services/funcionarioFranquiaService";
import { useAuth } from "../../contexts/AuthContext";
import { ProtectedRoute } from "../../components/ProtectedRoute";
import { Permission } from "../../types/auth";

const NovoFuncionarioContent: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<string>("");
  const { user } = useAuth();

  const handleSubmit = async (data: FuncionarioCreate) => {
    setLoading(true);
    setError("");

    try {
      // Obter ID da franquia do usuário logado
      const franquiaId = user?.franquia_membership?.franquia_id;

      if (!franquiaId) {
        throw new Error("Usuário não está associado a uma franquia");
      }

      // Converter dados para o formato da API
      const dadosAPI = FuncionarioFranquiaService.formatarDadosParaAPI(data);

      // Criar novo membro
      await funcionarioFranquiaService.adicionarMembro(franquiaId, dadosAPI);

      // Redirecionar para lista de funcionários
      navigate("/funcionarios");
    } catch (error: any) {
      console.error("Erro ao criar funcionário:", error);
      setError(
        error.response?.data?.message ||
          error.message ||
          "Erro ao criar funcionário. Tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold text-[#29306a]">
            Adicionar Novo Funcionário
          </h1>
          <p className="mt-2 text-sm text-[#64748b]">
            Preencha os dados para adicionar um novo funcionário à franquia
          </p>
        </div>

        {error && (
          <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-400"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">
                  Erro ao adicionar funcionário
                </h3>
                <div className="mt-2 text-sm text-red-700">
                  <p>{error}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="bg-white shadow sm:rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <FuncionarioForm
              onSubmit={handleSubmit}
              loading={loading}
              isEditing={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const Novofuncionario: React.FC = () => {
  return (
    <ProtectedRoute permission={Permission.MANAGE_USERS}>
      <NovoFuncionarioContent />
    </ProtectedRoute>
  );
};
